var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoInstagram1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.1,
    height: 17.096,
    viewBox: "0 0 17.1 17.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M8.546,6.4a4.383,4.383,0,1,0,4.383,4.383A4.376,4.376,0,0,0,8.546,6.4Zm0,7.233a2.85,2.85,0,1,1,2.85-2.85,2.855,2.855,0,0,1-2.85,2.85Zm5.585-7.412A1.022,1.022,0,1,1,13.109,5.2,1.02,1.02,0,0,1,14.131,6.223Zm2.9,1.038a5.059,5.059,0,0,0-1.381-3.582A5.093,5.093,0,0,0,12.071,2.3c-1.411-.08-5.642-.08-7.053,0A5.085,5.085,0,0,0,1.436,3.675,5.076,5.076,0,0,0,.055,7.257c-.08,1.411-.08,5.642,0,7.053a5.059,5.059,0,0,0,1.381,3.582,5.1,5.1,0,0,0,3.582,1.381c1.411.08,5.642.08,7.053,0a5.059,5.059,0,0,0,3.582-1.381,5.093,5.093,0,0,0,1.381-3.582c.08-1.411.08-5.638,0-7.05Zm-1.823,8.564a2.885,2.885,0,0,1-1.625,1.625c-1.125.446-3.8.343-5.039.343s-3.918.1-5.039-.343a2.885,2.885,0,0,1-1.625-1.625c-.446-1.125-.343-3.8-.343-5.039s-.1-3.918.343-5.039A2.885,2.885,0,0,1,3.507,4.121c1.125-.446,3.8-.343,5.039-.343s3.918-.1,5.039.343a2.885,2.885,0,0,1,1.625,1.625c.446,1.125.343,3.8.343,5.039S15.657,14.7,15.211,15.825Z",
    transform: "translate(0.005 -2.238)",
    fill: "#273375"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoInstagram1);
export default __webpack_public_path__ + "static/media/picto_instagram_1.70400477c32aeda62c4cb933485f47b4.svg";
export { ForwardRef as ReactComponent };